import React, { Component } from 'react';
import ProjectHeader from '../ProjectHeader';

import { store, showPreview } from '../_App/redux';

class ProjectBranding extends Component {
	photos = this.importAll();

	importAll() {
		let photosObj = [];
		const url = require.context('./../../assets/images/branding/', false, /\.(png|jpe?g|svg)$/);
		const imagesFolder = url.keys().map(url);
		imagesFolder.forEach((imageUrl) => {
			photosObj.push({
				src: imageUrl
			});
		});
		return photosObj;
	}

	openPreview(photo) {
		store.dispatch(showPreview( photo ));
	}

	render() {
		return (
			<div className="publish-container__wrapper is-wide">
				<ProjectHeader />
				<h1 className="title-h1 bold">Branding</h1>
				<span className="title-caption step-4">Logos I made for some projects I've worked on.</span>
				<div className="publish-container">
					<div className="gallery">
						{this.photos.map((photo, index) => (
							<div className="gallery__image hoverable" key={index} >
								<img alt="Preview" src={photo.src} onClick={() => { this.openPreview( photo.src ) }}/>
							</div>
						))}
					</div>
				</div>
			</div>
		);
	}
}

export default ProjectBranding;